import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Core2Config} from '../shared/core2Config';
import {BasicApiResponseModel} from '../shared/api-response.model';
import {LoginResponseDtoModel} from '../../data-transfer-objects/login-response-dto.model';

interface LoginRequestDtoInterface {
  email: string;
  password: string;
}

@Injectable({providedIn: 'root'})
export class AuthLoginApiService {

  constructor(
    private httpClient: HttpClient) {
  }

  signin(email: string, password: string) {
    const API_URL = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'identity/login';
    const requestData = <LoginRequestDtoInterface> {
      email: email,
      password: password
    };
    return this.httpClient.post<BasicApiResponseModel<LoginResponseDtoModel>>(API_URL, requestData);
  }
}
